import { Children, createContext, ReactElement, useState } from 'react';
import { TabHeader } from './tab-header.component';
import './tabs.component.scss';
import { TabProps } from './tab.component';

export const TabsContext = createContext(0);

export interface TabsProps {
    children: ReactElement<TabProps> | ReactElement<TabProps>[];
    onTabChange?: (tab: number) => void;
    className?: string;
}

const Tabs = ({ className, children, onTabChange }: TabsProps) => {
    const [selectedTab, setSelectedTab] = useState(0);

    const changeTab = (tab: number) => {
        if (onTabChange) {
            onTabChange(tab);
        }
        setSelectedTab(tab);
    };

    const childs = Children.toArray(children) as ReactElement<TabProps>[];
    const headers = Children.map(children, (child, i) => (
        <TabHeader index={i} onSelect={() => changeTab(i)} key={i}>
            {child.props.header}
        </TabHeader>
    ));
    const content = childs[selectedTab].props.children;
    return (
        <TabsContext.Provider value={selectedTab}>
            <div className={`tabs ${className || ''}`}>
                <div className="tabs__header">{headers}</div>
                <div className="tabs__content">{content}</div>
            </div>
        </TabsContext.Provider>
    );
};

export default Tabs;
